@import "helper/scss-helper";
$small-padding: 32px;
$large-padding: 48px;
$mobile-grid-padding: 24px;

:host {
  display: block;
  @include eon-typography();
  @include slotted-margins("*:not([slot])");

  * {
    box-sizing: border-box;
    outline: 0 none;
    text-rendering: optimizelegibility;
  }
}

* {
  position: relative;
}

.#{$prefix}offset-teaser-wrapper {
  display: flex;
  position: relative;

  &::before {
    position: absolute;
    top: 0px;
    bottom: 0px;
    right: 0px;
    width: percentage(customDivide(2, 3));

    content: "";
    background-color: var(--visibleBackgroundColor);
    @include borderRadius("variant_five", "content");
    @include boxShadow("variant_five", "content");

    @include for-size(phone) {
      width: 100%;
      margin-right: 0px;
    }

    @include for-size(desktop) {
      min-width: 320px;
    }

    @include for-size(tablet) {
      min-width: 320px;
    }
  }

  @include for-size(phone) {
    display: block;
    padding: 48px 24px;
  }

  .#{$prefix}image-layer {
    flex: 1 1 0%;
    padding: 48px 0px;
    .#{$prefix}offset-teaser-headline {
      color: v(headlineColor);
    }

    @include for-size(phone) {
      width: 100%;
      padding: 0px;
    }
  }

  .#{$prefix}content-layer {
    @include borderRadius("variant_five", "content");
    overflow: initial;
    .#{$prefix}content-wrapper {
      display: flex;
      flex-direction: column;

      &.#{$prefix}alignment-left {
        align-items: flex-start;
        .#{$prefix}offset-teaser-content {
          text-align: left;
        }
      }
      &.#{$prefix}alignment-center {
        align-items: center;
        .#{$prefix}offset-teaser-content {
          text-align: center;
        }
      }
      &.#{$prefix}alignment-right {
        align-items: flex-end;
        .#{$prefix}offset-teaser-content {
          text-align: right;
        }
      }
    }

    // Value for desktop and desktop-large. It will be overwritten with media queries.
    --headline-offset: 80px;

    // width of background panel (content Layer) = 2/3 width of the whole component with right padding of 32px on Desktop and Tablet viewports
    width: calc(2 / 3 * 100% - 2 * #{$small-padding} - var(--headline-offset));
    padding: 48px;

    // width of background panel (content Layer) = 2/3 width of the whole component with right padding of 48px on Desktop XL viewport
    @include for-size(desktop-l) {
      width: calc(2 / 3 * 100% - 2 * #{$large-padding} - var(--headline-offset));
    }

    @include for-size(desktop-or-smaller) {
      padding: 48px 32px;
    }

    @include for-size(desktop) {
      --headline-offset: 88px;
    }

    @include for-size(tablet) {
      --headline-offset: 72px;
    }

    @include for-size(tablet-or-larger) {
      background-color: v(visibleBackgroundColor);
    }

    @include for-size(phone) {
      width: 100%;
      padding: 0px;
      margin-top: 24px;
    }

    .#{$prefix}offset-teaser-subheadline {
      color: v(contentColor);
      display: block;

      @include for-size(desktop-or-larger) {
        padding-bottom: 24px;
      }

      @include for-size(tablet-or-smaller) {
        padding-bottom: 16px;
      }
    }

    .#{$prefix}offset-teaser-content {
      display: block;

      @include for-size(tablet-or-larger) {
        padding-bottom: 30px;
      }

      @include for-size(phone) {
        padding-bottom: 22px;
      }
    }
  }
}

::slotted(*) {
  color: v(contentColor);
}

::slotted(eon-ui-link) {
  --contentColor: var(--linkColor) !important;
  --contentHoverColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistColor: var(--linkColor);
  --linklistHoverColor: var(--linkHoverColor);
}

::slotted(eon-ui-image) {
  @include borderRadius("variant_five", "image");
  @include boxShadow("variant_five", "image");
}
